/**
 * @author Jafar Amini in March 2018.
 */
import {ValidationSrcType} from './validation-src-type';

export class ValidationOptions {
  validationSrcType: ValidationSrcType;
}
